module.exports = __webpack_public_path__ + "img/icon-counter-comment.a02f7a87.svg";